export default "__VITE_ASSET__BZrLISXD__"